import { type ChangeEvent, useId } from 'react'
import { _x } from '@wordpress/i18n'
import { useFilters } from './EventsFiltersController'

type TypeFilterProps = {
  ariaLabel: string
  title?: string
}

function TypeFilter(props: TypeFilterProps) {
  const id = useId()

  const { type, refineType } = useFilters()

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as 'offers' | 'events' | ''
    refineType(value || undefined)
  }

  const inputName = `type-filter-${id}`

  const allLabelText = _x('All', 'Events List Type Filter', 'icf')
  const offersLabelText = _x('Offers', 'Events List Type Filter', 'icf')
  const eventsLabelText = _x('Events', 'Events List Type Filter', 'icf')

  return (
    <fieldset aria-label={props.ariaLabel}>
      {props.title && <legend className="filter-title">{props.title}</legend>}
      <div className="tabs tabs--three tabs-sm filter-panel-tabs type-filter">
        <input
          type="radio"
          name={inputName}
          id={`type-filter-all-${id}`}
          className="btn-check"
          checked={type === undefined}
          value=""
          onChange={handleChange}
        />
        <label
          htmlFor={`type-filter-all-${id}`}
          className="btn tabs-button"
          title={allLabelText}
        >
          <span className="text">{allLabelText}</span>
        </label>
        <input
          type="radio"
          name={inputName}
          id={`type-filter-offers-${id}`}
          className="btn-check"
          checked={type === 'offers'}
          value="offers"
          onChange={handleChange}
        />
        <label
          htmlFor={`type-filter-offers-${id}`}
          className="btn tabs-button"
          title={offersLabelText}
        >
          <span className="text">{offersLabelText}</span>
        </label>
        <input
          type="radio"
          name={inputName}
          id={`type-filter-events-${id}`}
          className="btn-check"
          checked={type === 'events'}
          value="events"
          onChange={handleChange}
        />
        <label
          htmlFor={`type-filter-events-${id}`}
          className="btn tabs-button"
          title={eventsLabelText}
        >
          <span className="text">{eventsLabelText}</span>
        </label>
      </div>
    </fieldset>
  )
}

export default TypeFilter
